'use strict';

import Component from '../Component';
import ComponentDataManager from '../ComponentDataManager';
import ComponentRegistry from '../ComponentRegistry';
import ComponentRenderer from '../ComponentRenderer';

export default Component;
export {
	Component,
	ComponentDataManager,
	ComponentRegistry,
	ComponentRenderer,
};
export * from '../events/events';
